export enum Role {
  owner = "owner",
  developer = "developer",
  business = "business",
  collaborator = "collaborator",
  observer = "observer",
}

export const Roles = Object.keys(Role).map(
  (key) => Role[key as Role],
) as Role[];
